// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IN4i","colBig":"styles_colBig__36qD1","colSmall":"styles_colSmall__2JGAE"};